import PropTypes from 'prop-types';
import React from 'react';
const BackgroundSlideshowImage = ({ image }) => (
  <div
    className="each-slide-effect"
  >
    <div
      style={{
        backgroundImage: `url("${image.url}")`,
        flexShrink: 0,
        minWidth: '100%',
        minHeight: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
  </div>
);
BackgroundSlideshowImage.propTypes = {
  image: PropTypes.object,
  slideShow: PropTypes.object,
};

export default BackgroundSlideshowImage;
